import { useStore } from 'effector-react'
import { $withdrawalGroup, createWithdrawalGroup } from './model'

export const useCreateWithdrawalGroup = () => {
  const withdrawalGroup = useStore($withdrawalGroup)
  const loading = useStore(createWithdrawalGroup.pending)

  return { withdrawalGroup, loading }
}
